import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "counter"]

  connect() {
    this.updateCounter()
    this.addChangeListener()
  }

  addChangeListener() {
    this.selectTarget.addEventListener('change', () => {
      this.updateCounter()
    })
  }

  updateCounter() {
    const selectedOptions = this.selectTarget.selectedOptions
    const count = selectedOptions.length

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = count > 0 ? `${count} selected` : "None selected"
      this.counterTarget.className = count > 0
        ? "mt-1 text-xs text-green-600 font-medium"
        : "mt-1 text-xs text-gray-500"
    }
  }

  // Show selected skills on focus
  focus() {
    this.selectTarget.style.borderColor = "#78a3cf"
  }

  // Maintain visual feedback on blur
  blur() {
    this.selectTarget.style.borderColor = "#d1d5db"
    this.updateCounter()
  }
}